import commonConstant from '../../common/_commonConstant';

export const hideErrorMessage = () => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.HIDE_ERROR_MESSAGE,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.HIDE_ERROR_MESSAGE,
        'dateTime': new Date(),
      });
    }
  }
);
